function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup59645(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59645",
    transform: "translate(-1605 -1458)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2523",
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    transform: "translate(1605 1458)",
    style: {
      fill: "#612166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "phone-receiver-silhouette (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29794",
    d: "M24.475 19.85c-1.723-1.474-3.475-2.366-5.175-.895l-1.016.889c-.743.646-2.126 3.662-7.47-2.486S8.652 10.262 9.4 9.622l1.022-.89c1.693-1.475 1.054-3.331-.167-5.242l-.741-1.158C8.288.425 6.952-.827 5.255.646l-.917.8a8.609 8.609 0 0 0-3.356 5.7C.37 11.193 2.3 15.83 6.725 20.917s8.745 7.646 12.843 7.6a8.632 8.632 0 0 0 6.106-2.529l.92-.8c1.693-1.471.641-2.969-1.083-4.446z",
    transform: "translate(1629.128 1482)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup59645);
export default __webpack_public_path__ + "static/media/Group 59645.c64011b9e4f90965a92d10a4bb9d602d.svg";
export { ForwardRef as ReactComponent };